import type { FilterPanelCheckItem } from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'
import Group from 'components/utils/Group'
import { FormattedMessage } from 'react-intl'

/**
 * Leaf helper for rendering cruise filter checkbox panel items.
 * Kept out of CruiseExtraFiltersInputs so individual filter inputs can use it
 * without the CruiseExtraFiltersInputs ↔ filter component cycles.
 */
export function buildPanelCheckItems(
  items: Array<{ slug: string; label: string; count?: number }>,
  searchString?: string,
): Array<FilterPanelCheckItem> {
  if (items.length === 0) return []

  return items.map((item): FilterPanelCheckItem => ({
    value: item.slug,
    hidden: !!(searchString && items.length > 5 && !item.label.toLowerCase().includes(searchString.toLowerCase())),
    label: (
      <Group direction="horizontal" horizontalAlign="space-between">
        {item.label}
        {item.count != null && <span><FormattedMessage
          id="arX42MPD0JqMrUrbZ2wr"
          defaultMessage="({count})"
          description="Count of matching cruise offers for a filter option in cruise search"
          values={{ count: item.count }}
        />
        </span>}
      </Group>
    ),
  }))
}
